// This file is auto-generated by scripts/write-build-info.mjs.
export const APP_VERSION: string = "1.5.0";
export const BUILD_TARGET: 'development' | 'test' | 'production' = "production";
export const BUILD_NUMBER: string | null = "260920831";
export const BUILD_LABEL: string | null = null;
